const footerLinks = [
  {
    url: 'https://www.clairecorbett.com/',
    title: 'ClaireCorbett.com'
  }
];

export default footerLinks;